module.exports = {"441521101":"梅陇镇","441521102":"小漠镇","441521105":"鮜门镇","441521106":"联安镇","441521107":"陶河镇","441521108":"赤坑镇","441521109":"大湖镇","441521110":"可塘镇","441521112":"黄羌镇","441521113":"平东镇","441521115":"海城镇","441521116":"鹅埠镇","441521117":"赤石镇","441521118":"公平镇","441521119":"附城镇","441521120":"城东镇","441521450":"梅陇农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/441521.json
// module id = 1859
// module chunks = 0